import {
  AlphabetFilterSchema,
  NameFilterSchema,
} from '@vs-shop/schemas/url/queryParams/glossaryFilters';
import {
  alphabetFilterParamName,
  glossaryNameFilterParamName,
} from '@vs-shop/schemas/config/urlParams';
import { Option } from 'effect';
import * as Atom from 'effect/unstable/reactivity/Atom';

import type { GlossaryMode } from '../../data/glossary/glossaryMode';
import { deriveGlossaryMode } from '../../data/glossary/glossaryMode';

export const alphabetFilterSearchParamAtom = Atom.searchParam(alphabetFilterParamName, {
  schema: AlphabetFilterSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

export const nameFilterSearchParamAtom = Atom.searchParam(glossaryNameFilterParamName, {
  schema: NameFilterSchema,
}).pipe(Atom.withServerValue(() => Option.none()));

export const currentAlphabetFilterAtom = Atom.map(
  alphabetFilterSearchParamAtom,
  (option): string | null => Option.getOrElse(option, () => null)
);

export const currentNameFilterAtom = Atom.map(nameFilterSearchParamAtom, (option): string | null =>
  Option.getOrElse(option, () => null)
);

export const glossaryModeAtom = Atom.readable<GlossaryMode>((ctx) =>
  deriveGlossaryMode({
    nameFilter: ctx.get(currentNameFilterAtom),
    alphabetFilter: ctx.get(currentAlphabetFilterAtom),
  })
);
